module.exports = __webpack_public_path__ + "img/inhouseSeminar2.fc15f33a.jpg";